<template>
  <div>
    <component class="home" :is="pageTemplate" :key="key"></component>
    <newsletter-horizontal />
  </div>
</template>

<script>
import split from "lodash/split";

import category from "~/mixins/category";
import login from "~/mixins/login";
import deliveryReactive from "~/mixins/deliveryReactive";
import categoryTemplate from "@/mixins/categoryTemplate";
import NewsletterHorizontal from "@/components/cards/NewsletterHorizontal.vue";

import CartInfoList from "@/components/cart/CartInfoList.vue";
import CategoryTitle from "@/components/category/CategoryTitle.vue";
import CustomerCardHorizontalVue from "@/components/categoryBlock/elements/CustomerCardHorizontal.vue";

export default {
  name: "HomeSite",
  mixins: [category, deliveryReactive, login, categoryTemplate],
  components: {
    CartInfoList,
    CategoryTitle,
    NewsletterHorizontal,
    CustomerCardHorizontalVue
  },
  data() {
    return {
      key: 1
    };
  },
  methods: {
    async reload() {
      let slug = split(this.category.slug, "@")[0];
      await this.resetFilters(slug);
      await this.setCategory({ slug: slug, force: true });

      this.key += 1;
    }
  },
  mounted() {
    global.EventBus.$on("login", () => {
      if (this.$vuetify.breakpoint.xs) {
        this.$vuetify.goTo(0, { duration: 0 });
      }
    });
  }
};
</script>
